import { FC, useEffect, useState } from 'react';
import { t } from "../app/Translate";
import "./FormContact.css";
import { Link } from 'react-router-dom';

interface HeaderProps{
    isocode: string      
}
   
const FormContact: FC<HeaderProps> = ({ isocode }) => {       

    const [nombre, setNombre] = useState("");
    const [correo, setCorreo] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [acepto, setAcepto] = useState(false);
    const [isvisible, setIsVisible] = useState(false);

    const [toast, setToast] = useState({ show: false, message: "", type: "" });

    const showToast = (message:string, type = "error") => {
        setToast({ show: true, message, type });
        setTimeout(() => setToast({ show: false, message: "", type: "" }), 3000);
    };

    function validarEmail(email: string) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    const handleSubmit = async (e:any) => {
        e.preventDefault();

        if (!nombre || !correo || !mensaje) {
            showToast(t("formcontact.form-error"), "error");
            return;
        }

        if (!acepto) {
            showToast(t("formcontact.form-accept"), "error");
            return;
        }

        if (!validarEmail(correo)){
            showToast(t("formcontact.form-validemail"), "error");
            return;
        }

        try {
            const response = await fetch("https://api.helpdeskmakos.com/notify/contact", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",                 
                },
                body: 
                JSON.stringify({
                    email: correo,
                    name: nombre,
                    msg: mensaje               
                })
            });

            if (!response.ok) {
                showToast(t("formcontact.form-errortotal"), "error");
            }            
            showToast(t("formcontact.form-success"), "success");

        } catch (err) {
            showToast(t("formcontact.form-errortotal"), "error");
        }
        setIsVisible(true)     
                    
    };

    return(
        <section className='formcontact'>            
            <h2 className="formcontact-title" style={{marginTop:"40px"}}>{t("formcontact.title")}</h2>
            <h3 className="formcontact-subtitle">{t("formcontact.subtitle")}</h3>
            <div className='row formcontact-form'  style={{textAlign:"left", marginTop:"40px"}}>
                <div className='col-md-2'></div>
                <div className='col-md-8'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label>{t("formcontact.form-name")}</label>
                                <input type="text" required maxLength={40} inputMode='text' value={nombre} onChange={(e) => setNombre(e.target.value)} />
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label>{t("formcontact.form-email")}</label>
                                <input type="email" required maxLength={100} inputMode='email' value={correo} onChange={(e) => setCorreo(e.target.value)} />
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className="form-group">
                                <label>{t("formcontact.form-text")}</label>
                                <textarea rows={4} maxLength={500} value={mensaje} onChange={(e) => setMensaje(e.target.value)}></textarea>
                            </div>
                            <div className="form-checkbox">
                                <input type="checkbox" id="acepto" checked={acepto} onChange={(e) => setAcepto(e.target.checked)}/>
                                <Link to={t("terms.url")} className='linkterms' target="_blank">{t("formcontact.form-checkmsg")}</Link>                        
                            </div>
                            <div style={{textAlign:"right", width:"100%"}}>
                                <button type="submit" onClick={handleSubmit} disabled={isvisible}  className="animated-button">{t("formcontact.form-button")}</button>
                            </div>                    

                            {toast.show && (
                                <div className={`toast ${toast.type}`}>
                                {toast.message}
                                </div>
                            )}
                        </div>                

                    </div>
                </div>      
                <div className='col-md-2'></div>          
            </div>            
        </section>
    )
}


export default FormContact;